<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-8">
                        <div class="font-weight-bold body-1">
                            Nueva Requisición
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="8">
                        <v-form ref="form" @submit.prevent="save">
                            <requisition-form ref="RequisitionForm" :values="form" @save="save" :serverErrors="serverErrors"></requisition-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="8" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button data-cy="cancel-btn" :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button data-cy="accept-btn" :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Object2Form from '../../../helpers/Object2Form';
import Utils from '../../../helpers/Utils';
import RequisitionForm from "./Form.vue";
export default {
    components: {
        'requisition-form': RequisitionForm,
    },
	data(){
		return {
            loading: false,
            serverErrors: {},
            form: {
                
              

                //new form
                date: Utils.getNowDate(),
                priority: 1,
                client_id: "",
                client_product_id: "",
                warehouse_id: "",
                observations: "",
                supplies: [
                    // {
                    //     id:1,
                    //     part: "1",
                    //     description: "camas de pescado hd para exteriores",
                    //     unit: "pieza",
                    //     quantity: 1,
                    // },
                    // {
                    //     id:2,
                    //     part: "1",
                    //     description: "camas de pescado hd para exteriores dohjfsdihf lskdfh ksdjf hdlsifusydfhlisudfhl isdufh lsdifuhsdfiu",
                    //     unit: "pieza",
                    //     quantity: 1,
                    // }
                ],

                    
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Requisitions",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        
    },
	methods: {

       
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        save(){
            
            console.log(this.prepareRequest(this.form));
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                console.log(form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.requisition.store(form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'Requisitions'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("errors" in error.response.data)){
                                    if(error.response.data.errors instanceof Object){
                                        Object.keys(error.response.data.errors).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.errors;
                                            error.response.data.errors[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.errors)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario incompleto`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));

            if(data.priority)
                data.priority = 1;
            
            for (let i = 0; i < data.supplies.length; i++) {
                delete data.supplies[i].name;
                delete data.supplies[i].actions;
                delete data.supplies[i].parameters;
                if(request.supplies[i].visual_support.length >=1)
                    data.supplies[i].visual_support = request.supplies[i].visual_support;
                else
                    data.supplies[i].visual_support = ""
                
            }
            return Object2Form.objectToFormData(data, "", []);
        }
    },
}
</script>

<style>

</style>